import useEnvService from '@hooks/app/useEnvService';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { actions as chatActions } from '../../store/ducks/direct-chat';
import { actions as lifeIdActions } from '../../store/ducks/life-id';
import { actions } from '../../store/ducks/patients';
import { actions as userActions } from '../../store/ducks/users';
import TStore from '../../types/store';
import { TSearchParams } from '../../types/users';
import MobileBar from './components/mobile-bar';
import VitalSidebar from './components/vital-sidebar';
import { LifeIdSC, VitalColSC } from './life-id.styled';

const INTERVAL = 1000 * 30;

type TProps = {} & RouteComponentProps &
  ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

const LifeIdMobile: React.FC<TProps> = ({
  match,
  providerId,
  getPatientDetailRequest,
  getGeneralInfoRequest,
  getVitalDataById,
  getBehavioralDataById,
  getVitalDataIntervals,
}) => {
  const { userId }: any = match.params;
  const [env] = useEnvService();

  const chatWithHilbi = userId === env.xmpp.hilbiId;

  useEffect(() => {
    getGeneralInfoRequest(providerId, userId);
    const interval = setInterval(() => {
      getGeneralInfoRequest(providerId, userId);
    }, INTERVAL);
    return () => clearInterval(interval);
  }, [providerId, userId, getGeneralInfoRequest]);

  useEffect(() => {
    getPatientDetailRequest(providerId, userId);
    const interval = setInterval(() => {
      getPatientDetailRequest(providerId, userId);
    }, INTERVAL);
    return () => clearInterval(interval);
  }, [providerId, userId, getPatientDetailRequest]);

  useEffect(() => {
    getVitalDataById(providerId, userId);
    const interval = setInterval(() => {
      getVitalDataById(providerId, userId);
    }, INTERVAL);
    return () => clearInterval(interval);
  }, [providerId, userId, getVitalDataById]);

  useEffect(() => {
    getBehavioralDataById(userId);
    const interval = setInterval(() => {
      getBehavioralDataById(userId);
    }, INTERVAL);
    return () => clearInterval(interval);
  }, [userId, getBehavioralDataById]);

  useEffect(() => {
    getVitalDataIntervals(providerId, userId);
    const interval = setInterval(() => {
      getVitalDataIntervals(providerId, userId);
    }, INTERVAL);
    return () => clearInterval(interval);
  }, [providerId, userId, getVitalDataIntervals]);

  return (
    <>
      {/* <LifeIdBreadcrumbs /> */}
      <LifeIdSC style={{ flexDirection: 'column' }}>
        <MobileBar userId={userId} activeKey="life-id" />
        {!chatWithHilbi && (
          <VitalColSC style={{ width: '100%', flex: 1 }}>
            <VitalSidebar userId={userId} />
          </VitalColSC>
        )}
      </LifeIdSC>
    </>
  );
};

const mapStateToProps = (store: TStore) => ({
  connectionStatus: store.xmpp.status,
  messagesLoading: store.directChat.isLoading,
  patientDetail: store.patients.patientDetail,
  twilioRoomData: store.twilio.twilioRoomData,
  // eVisitCurrentEvent: store.eVisits.singleEvisitItem,
  twilioErrorMessage: store.twilio.twilioErrorMessage,
  providerId: store.users.business[0].id,
  reqStatus: store.twilio.joinTwilioRoomRequestStatus,
});

const mapDispatchToProps = (dispatch: any) => ({
  getPatientDetailRequest: (providerId: string, id: string) =>
    dispatch(actions.getPatientDetailRequest(providerId, id)),
  getMessagesRequest: (from: string) => dispatch(chatActions.getMessagesRequest(from)),
  setReceiver: (receiver: string) => dispatch(chatActions.setReceiver(receiver)),
  postSearchRequest: (providerId: string, query: TSearchParams) =>
    dispatch(userActions.postSearchRequest({ providerId, ...query })),
  resetMessages: () => dispatch(chatActions.resetMessages()),
  getGeneralInfoRequest: (providerId: string, id: string) =>
    dispatch(lifeIdActions.getGeneralInfoRequest({ providerId, id })),
  getVitalDataById: (providerId: string, id: string) =>
    dispatch(lifeIdActions.getVitalDataRequest({ providerId, id })),
  getVitalDataIntervals: (providerId: string, id: string) =>
    dispatch(lifeIdActions.getVitalDataIntervalsRequest({ providerId, id })),
  getBehavioralDataById: (id: string) => dispatch(lifeIdActions.getBehavioralDataRequest(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LifeIdMobile);
